import { connect } from 'react-redux';
import type { AppDispatch, RootState } from 'src/store';
import { getGarmentWarpAvailability } from 'src/selectors/pages/editor';
import { requestGarmentPlacementRecompute } from './actions';
import recomputePlacement from './recomputePlacement';

const mapStateToProps = (state: RootState, ownProps: { id: string }) => {
    const availability = getGarmentWarpAvailability(state, ownProps.id);
    return {
        disabled: !availability.available,
        disabledReason: availability.available ? undefined : availability.reason,
    };
};

const mapDispatchToProps = (dispatch: AppDispatch, ownProps: { id: string }) => ({
    onClick: () => dispatch(requestGarmentPlacementRecompute({ id: ownProps.id })),
});

const recomputePlacementContainer = connect(mapStateToProps, mapDispatchToProps)(recomputePlacement);

export default recomputePlacementContainer;
